import { Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { environment } from 'src/environments/environment';
import { Observable, timer, switchMap, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenValidationService {
  private readonly TOKEN_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

  constructor(private authService: CalAngularService) {}

  startTokenValidation(): void {
    timer(0, this.TOKEN_CHECK_INTERVAL)
      .pipe(switchMap(() => this.validateAndRefreshToken()))
      .subscribe();
  }

  private validateAndRefreshToken(): Observable<boolean> {
    return this.authService.isUserSignedIn().pipe(
      switchMap((isSignedIn) => {
        if (!isSignedIn) {
          return of(false);
        }

        // Check if token is still valid by trying to get it
        return this.authService.getAADToken([environment.apiTokenScope]).pipe(
          switchMap(() => of(true)),
          catchError(() => {
            // Token is expired or invalid, try silent refresh
            return this.authService.userInitiatedSignIn().pipe(
              switchMap(() => of(true)),
              catchError(() => {
                // Silent refresh failed, need to re-authenticate
                console.warn('Token refresh failed, redirecting to login');
                this.authService.userInitiatedSignIn();
                return of(false);
              })
            );
          })
        );
      })
    );
  }

  validateTokenManually(): Observable<boolean> {
    return this.validateAndRefreshToken();
  }
}
